import {css} from "emotion";
import {AuthType} from "@app/ir-q-app-common/types/activation";

export const createNewBtnStyle = css({
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: "22px",
    textAlign: "center",
    background: "#487CFF",
    color: "white",
    height: "40px",
    width: "160px",
    borderRadius: "5px",
    border: "none",
    cursor: "pointer",
    marginRight: 30
});

export type ActivationRow = {
    created: number,
    auditBy: string,
    firstName: string,
    lastName?: string,
    unitId: string,
    som_serial?: string,
    tablet_serial?: string,
    replacement_tablet_serial?: string | null,
    authType: AuthType,
    actions: undefined,
    pincode?: string,
    activated?: boolean,
    contactUpdatedAfterUnitDelete?: boolean
}
